import React, { useState, useRef, useEffect } from "react";
import { APIForwardGeocode } from "../../config/utilities/APIs/stopsApi";
import LoadingSpinner from "../loading/LoadingSpinner";
import "./MapSearchBar.css";

const MapSearchBar = ({
  onSearchResult,
  placeholder,
  width = "100%",
  disabled,
  debounceDelay = 500,
}) => {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [loading, setLoading] = useState(false);
  const dropdownRef = useRef(null);
  const debounceTimer = useRef(null);

  const handleInputChange = async (e) => {
    const query = e.target.value;
    setQuery(query);

    if (!query.trim()) {
      setSuggestions([]);
      setShowOptions(false);
      return;
    }

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(async () => {
      setLoading(true);

      try {
        const response = await APIForwardGeocode(query, setLoading);
        if (response?.data && response.data.length > 0) {
          setSuggestions(response.data);
          setShowOptions(true);
        } else {
          setSuggestions([]);
          setShowOptions(false);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
        setShowOptions(false);
      } finally {
        setLoading(false);
      }
    }, debounceDelay);
  };

  const handleSuggestionClick = (location) => {
    const coordinates = {
      latitude: parseFloat(location.lat),
      longitude: parseFloat(location.lon),
    };
    setQuery(location.display_name);
    setSuggestions([]);
    setShowOptions(false);
    onSearchResult(coordinates, location.display_name);
  };

  const renderDropdownOptions = () => {
    return (
      <div className="dropdown-options">
        {suggestions.map((location) => (
          <div
            key={location.place_id}
            className="dropdown-option"
            onClick={() => handleSuggestionClick(location)}
          >
            {location.display_name}
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  return (
    <div className="text-input-container">
      <div className="dropdown" ref={dropdownRef}>
        <div className="dropdown-box" style={{ width: width }}>
          <input
            className="dropdown-box-search"
            type="text"
            value={query}
            onChange={handleInputChange}
            placeholder={placeholder}
            disabled={disabled}
          />
          {loading && (
            <div className="search-loading-indicator">
              <LoadingSpinner size="small" color="#ffb502" />
            </div>
          )}
          {showOptions && renderDropdownOptions()}
        </div>
      </div>
    </div>
  );
};

export default MapSearchBar;
